import * as React from 'react'

import { cn } from '../../utils/cn'

function Marker({ className, ...props }: React.ComponentProps<'span'>) {
  return <span data-slot="marker" className={cn('inline-flex items-center gap-2', className)} {...props} />
}

function MarkerIcon({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="marker-icon"
      className={cn('inline-flex shrink-0 items-center justify-center', className)}
      {...props}
    />
  )
}

function MarkerContent({ className, ...props }: React.ComponentProps<'span'>) {
  return <span data-slot="marker-content" className={cn(className)} {...props} />
}

export { Marker, MarkerContent, MarkerIcon }
